import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { BtnRapido, Cruce } from 'src/app/models';
import { postBtnRapido } from 'src/app/state/actions/btnRapido.actions';
import { addCruceCantidadEjes, addCruceClasificacion, postCruce } from 'src/app/state/actions/cruce.actions';
import { AppState } from 'src/app/state/app.state';
import { selectBtnRapido } from 'src/app/state/selectors/btnRapido.selectors';
import { selectPermisos } from 'src/app/state/selectors/caseta.selectors';
import { selectCruce } from 'src/app/state/selectors/cruce.selectors';
import { selectTipoVehiculo } from 'src/app/state/selectors/tipoVehiculo.selectors';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import { TYPE_CRUCE_PADRE, TYPE_PERMISO } from 'src/app/utils/enum';
import { finished } from 'stream';
import {foundPermiso} from '../../utils';
import { SolicitudesService } from 'src/app/services/solicitudes.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-ecc',
  templateUrl: './ecc.component.html',
  styleUrls: ['./ecc.component.scss']
})
export class EccComponent implements OnInit {
  eec = [
    { id: 4 },
    { id: 5 },
    { id: 6 },
    { id: 7 },
    { id: 8 },
    { id: 9 },
  ];
  tr = [
    { id: 1 },
    { id: 2 },
    { id: 3 },
  ];
  tiposVehiculo = [
    { id: 1, tipo: 'Moto', icon: 'ic_moto.svg' },
    { id: 2, tipo: 'Auto', icon: 'ic_auto.svg' },
  ];
  cruce: any = null;
  user: any = null;
  btnTemp: any
  clasificacion: number
  btnRapido: any = null;
  //permisos
  permisos = [];
  constructor(private store: Store<AppState>,
    private router: Router,
    private toastr: ToastrService,
        private solicitudesService: SolicitudesService,
        private ngxService:NgxUiLoaderService) { }

  ngOnInit(): void {

    this.store.select(selectBtnRapido).subscribe(btnRapido => this.btnRapido = btnRapido);

    console.log(this.btnRapido);

    this.store.select(selectCruce).subscribe(cruce => this.cruce = cruce);
    console.log(this.cruce);
    this.store.select(selectUser).subscribe(user => this.user = user);

    // Permisos para retirar o devolucion por roles
    this.store.select(selectPermisos).subscribe(permiso => {
      this.permisos = permiso
    });
    this.foundPermiso(TYPE_PERMISO.TR)
  }

  saveEcc(id) {

    //validar si es t+r debe seleccionar moto o auto.
    if (this.cruce.id_clasificacion == 3 && !this.clasificacion) {
      this.toastr.info('Seleciona Moto o Auto', '', { positionClass: 'toast-bottom-right' })

    } else {
      //validar si viene de botones rapidos
      if (this.btnRapido.id_subtipo) {
        // Se guarda la info de btnRapido
        let BtnRapido: BtnRapido = {

          fecha_hora: moment().format('YYYY-MM-DD HH:mm:ss'),
          id_subtipo: this.btnRapido.id_subtipo,
          id_corte_usuario: this.user.id_corte_usuario,
          id_clasificacion: this.clasificacion ? this.clasificacion : 14,//carga 9
          id_cat_observacion: this.btnRapido.id_cat_observacion,
          cantidad_ejes: id
        }
        this.store.dispatch(postBtnRapido({ btnRapido: BtnRapido }))
        this.router.navigate(['/mopa',]);
        this.finished();
      } else {
        //mandar al componente avento dinero si es eludido
        if (this.cruce.idPadre == TYPE_CRUCE_PADRE.ELUDIDOS) {
          this.store.dispatch(addCruceClasificacion({ id_clasificacion: this.clasificacion ? this.clasificacion : 14 }))
          this.store.dispatch(addCruceCantidadEjes({ cantidad_ejes: id }))
          this.router.navigate(['/mopa/dinero-eludido']);
        } else {
          let cruce: Cruce = {
            fecha_hora: moment().format('YYYY-MM-DD HH:mm:ss'),
            id_corte_usuario: this.user.id_corte_usuario,
            id_subtipo: this.cruce.idChildren,
            id_clasificacion: this.clasificacion ? this.clasificacion : 14,//carga 9
            id_cat_observacion: this.cruce.id_cat_observacion,
            cantidad_ejes: id
          }

          //obtener suptipo con id_padre para saber si es 5 (VSC)
          let subtipo=(this.cruce.childrens.find(child => child.id == this.cruce.idPadre).childrens).find(child => child.id == this.cruce.idChildren);
          //obtener la Var G para validar
          let variablesG: any[] = JSON.parse(localStorage.getItem('variablesGlobales')+"");
          //si se requiere validacion de JT y si es VSC mandar directo a JT sin importar la cantidad de caravanas
          const valor =Number(variablesG.find(variable => variable.id == 4).valor)
          if(valor === 1 && subtipo==5){
            //enviar directo para confirmacion de JT socket u otra alternativa
            this.ngxService.start();
            let dataForm:any={cruce:cruce, id_usuario: this.user.id_usuario}
            this.solicitudesService.crearSolicitud(dataForm).subscribe((response:any)=>{
              if (Number(response.id)>0) {
                console.log('Solicitud creada con ID:', response.id);
                this.listenSSE(response.id);
              }
            })
            this.router.navigate(['/mopa',]);
            this.finished();
            return;
          }








          this.store.dispatch(postCruce({ cruce }))
          this.finished()
        }
      }


    }

  }

  addClasificacion(id: number, tipo, btnClasificacion) {
    this.clasificacion = id;
    //estilo de botones
    this.isSelected(btnClasificacion)
    if (this.btnTemp) {
      this.isSelected(this.btnTemp)
    }
    this.btnTemp = btnClasificacion
    console.log(this.clasificacion);

  }

  returnPage() {
    this.router.navigate(['/mopa/subtipo/' + this.cruce.id_type])
  }

  isSelected(btn) {
    if (btn.classList.contains('selected')) {
      btn.classList.remove('selected');
      btn.classList.remove('dark:bg-blue-800');
      btn.classList.remove('bg-blue-800');
      btn.classList.remove('text-white');
      btn.classList.add('dark:bg-transparent');
    } else {
      btn.classList.add('selected');
      btn.classList.add('dark:bg-blue-800');
      btn.classList.add('bg-blue-800');
      btn.classList.add('text-white');
      btn.classList.remove('dark:bg-transparent');

    }
  }
  finished(){
    this.toastr.success('Cruce guardado con éxito', '', { positionClass: 'toast-bottom-right' })
    this.router.navigate(['/mopa'])
  }

  foundPermiso(id: number) {
    const permisos = foundPermiso(id, this.permisos);
    if (permisos.length > 0) {
      this.tr = [{ id: 1 }];
      console.log(this.tr);
    }
    return permisos
  }
  listenSSE(id: any) {
    this.solicitudesService.listenSolicitudes(id).subscribe((response:any)=>{

      console.log('Respuesta SSE:', response);

      if (!response.status || response.status === 'pending') {
        this.listenSSE(id)
        return;
      }

      this.ngxService.stop();

      if (response.status === 'approved') {
        this.toastr.success('Aprobado por jefe');
      }

      if (response.status === 'denied') {
        this.toastr.error('Rechazado');
      }
    })
  }
}
